import { types } from 'mobx-state-tree';

export interface TransactionBalanceProps {
  amount: number;
  currency: string;
  type: string;
}

export const TransactionBalance = types.model({
  amount: types.number,
  currency: types.string,
  type: types.string,
});

export interface SingleTransactionProps {
  account_number: string;
  amount: number;
  balance: TransactionBalanceProps;
  bank_slug: string;
  booking_date_time: number;
  category: string;
  category_type: string;
  currency: string;
  id: string;
  name: string;
  status: string;
  value_date_time: number;
}

export const SingleTransaction = types.model({
  account_number: types.string,
  amount: types.number,
  balance: TransactionBalance,
  bank_slug: types.string,
  booking_date_time: types.number,
  category: types.string,
  category_type: types.string,
  currency: types.string,
  id: types.string,
  name: types.string,
  status: types.string,
  value_date_time: types.number,
});
